module.exports = __webpack_public_path__ + "7e005de0409ca06b3540a1d594787064.svg";